import { render } from "./ChurnLtvPeriod.vue?vue&type=template&id=f372f992&scoped=true"
import script from "./ChurnLtvPeriod.vue?vue&type=script&lang=js"
export * from "./ChurnLtvPeriod.vue?vue&type=script&lang=js"

import "./ChurnLtvPeriod.vue?vue&type=style&index=0&id=f372f992&lang=scss&scoped=true"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f372f992"]])

export default __exports__